export var Field;
(function (Field) {
    Field["Filters"] = "filters";
    Field["Query"] = "q";
    Field["Sort"] = "sort";
    Field["Offset"] = "offset";
    Field["Limit"] = "limit";
})(Field || (Field = {}));
export var Facets;
(function (Facets) {
    Facets["text"] = "text";
    Facets["category"] = "category";
    Facets["range"] = "range";
})(Facets || (Facets = {}));
